import {
  getCommittedDeliveriesForProduct,
  getZoneDiscountRatesOnCommitedDeliveries,
  getSelectedWeightsPricesList,
  getPricesListOnDiscount,
  getDiscountedPrice,
} from '@/helpers/productListHelpers/productListGetters'

const getOfferWithInitializedPrices = offer => ({
  ...offer,
  productList: getProductListWithInitializedPrices(
    offer.productList,
    offer.clientCommitedDeliveries,
    offer.internationalShipments,
  ),
})

const getProductListWithInitializedPrices = (productList, numDeliveries, internationalDeliveries) =>
  productList.map(product =>
    getInitializedProduct(
      product,
      getCommittedDeliveriesForProduct(product, numDeliveries, internationalDeliveries),
    ),
  )

const getInitializedProduct = (product, numDeliveries) => {
  const hasProductAdditionalKg = product.AdditionalKg
  return {
    ...product,
    zoneList: getInitializedZoneList(
      product.zoneList,
      numDeliveries,
      product.fixedPrice,
      hasProductAdditionalKg,
      product.currentWeightIdList,
    ),
  }
}

const getInitializedZoneList = (
  zoneList,
  numDeliveries,
  fixedPrice,
  hasProductAdditionalKg,
  currentWeightIdList,
) =>
  zoneList.map(zone =>
    getInitializedZone(zone, numDeliveries, fixedPrice, hasProductAdditionalKg, currentWeightIdList),
  )

const getInitializedZone = (zone, numDeliveries, fixedPrice, hasProductAdditionalKg, currentWeightIdList) => {
  const discountRates = getZoneDiscountRatesOnCommitedDeliveries(zone, numDeliveries)

  //initialize amountOutOfDiscount
  const amountOutOfDiscount = discountRates.stdDiscountRate
  //initialize basePrices
  const pricesFilteredBySelectedWeights = getSelectedWeightsPricesList(
    zone.defaultPrices,
    currentWeightIdList,
  )
  const basePrices = getPricesListOnDiscount(pricesFilteredBySelectedWeights, amountOutOfDiscount, fixedPrice)

  if (!hasProductAdditionalKg) {
    return { ...zone, amountOutOfDiscount, basePrices }
  } else {
    //initialize additionalKgValue
    const additionalKgValue = getDiscountedPrice(zone.defaultAdditionalKgValue, amountOutOfDiscount)

    return { ...zone, amountOutOfDiscount, basePrices, additionalKgValue }
  }
}

export default getOfferWithInitializedPrices
